<template>
	<card class="filter-grid">
		<template v-slot:header>
			<input-text v-model="filters.search" inputmode="search" append-icon="essentials/search/find-circle" @keyup.enter="filters.page = 1; load()" @click:append="filters.page = 1; load()" label="Search..."></input-text>
			<div class="actions">
				<icon-link :to="createUrl" icon="essentials/basics/add-circle" v-if="createUrl && user.can(createPermission)">Add New</icon-link>
				<icon-button icon="essentials/search/filter-list-circle" @click="filtering = !filtering">Filter</icon-button>
			</div>
		</template>
		<template v-slot:under-header>
			<transition name="slide-down-displace">
				<div class="filters" v-if="filtering" @keyup.enter="load">
					<slot name="filters" :filters="filters.filters" :filter-data="filterData"></slot>
					<div class="actions">
						<icon-button @click.prevent="load" icon="arrows/cycle/reload">Go</icon-button>
					</div>
				</div>
			</transition>
		</template>
		<loader :loading="loading" class="card-loader"></loader>
		<pagination v-model="filters.page" :total="total"></pagination>
		<table class="filter-table" v-if="items.length > 0">
			<thead>
				<th v-for="(column, index) in visible" :class="index">
					<a href="#" @click.prevent="setSort(index)" :class="{active: filters.sort === index}">
						{{ column.name }}
						<transition name="fade" mode="out-in">
							<icon v-if="filters.dir === 'asc' && filters.sort === index" icon="essentials/search/sort-ascending" :key="index + '-sort-asc'"></icon>
							<icon v-else-if="filters.sort === index" icon="essentials/search/sort-descending" :key="index + '-sort-desc'"></icon>
						</transition>
					</a>
				</th>
				<th class="actions"></th>
			</thead>
			<tbody v-for="(item, i) in items" :key="'item-' + item.id" @click.prevent="navigate(item)">
				<tr>
					<td v-for="(column, index) in visible" :class="'column-' + ((column.type)?column.type:'text') + ' ' + index">
						<lazy-background v-if="column.type === 'image'" :src="getValue(index, item)"></lazy-background>
						<span v-if="!column.type || column.type === 'text'">{{ getValue(index, item) }}</span>
					</td>
					<td class="actions">
						<a href="#" @click.prevent.stop="deleting = item" v-if="user.can(deletePermission)">
							<icon icon="essentials/basics/close-circle"></icon>
						</a>
						<router-link :to="editUrl + '/' + item.id" v-if="user.can(editPermission) && viewUrl" @click.native.prevent.stop="">
							<icon icon="essentials/settings/edit-circle"></icon>
						</router-link>
						<transition name="fade" mode="out-in">
							<a href="#" @click.prevent.stop="item.open = !item.open" v-if="Object.keys(hidden).length > 0">
								<icon icon="arrows/chevron/chevron-left-circle" :style="{transform: 'rotate(' + ((item.open)?'-90deg':'0deg') + ')'}"></icon>
							</a>
						</transition>
					</td>
				</tr>
				<tr v-if="item.open && Object.keys(hidden).length > 0">
					<td :colspan="Object.keys(visible).length + 1">
						<table>
							<tr v-for="(column, index) in hidden">
								<th>{{ column.name }}</th>
								<td>
									<lazy-background v-if="column.type === 'image'" :src="getValue(index, item)"></lazy-background>
									<span v-if="!column.type || column.type === 'text'">{{ getValue(index, item) }}</span>
								</td>
							</tr>
						</table>
					</td>
				</tr>
			</tbody>
		</table>
		<p v-if="items.length === 0">There are currently no {{ plural }} to view. Why not add one?</p>
		<pagination v-model="filters.page" :total="total"></pagination>
		<modal v-model="deleting" :disabled="deleteLoading">
			<template v-slot:header><h3>Delete {{ (deleting)?deleting[displayKey]:'' }}</h3></template>
			<loader :loading="deleteLoading"></loader>
			<p>Are you sure you really wish to delete {{ (deleting)?deleting[displayKey]:'' }}? Doing so will make this {{ single }} only appear in legacy data.</p>
			<template v-slot:footer>
				<icon-button icon="essentials/alerts/cancel" class="warning" @click="deleting = null" :disabled="deleteLoading">Cancel</icon-button>
				<icon-button icon="essentials/basics/check-circle" class="danger" @click="deleteItem" :disabled="deleteLoading">Delete</icon-button>
			</template>
		</modal>
	</card>
</template>

<script>
	export default {
		props: ['initUrl', 'dataUrl', 'createUrl', 'editUrl', 'deleteUrl', 'createPermission', 'editPermission', 'deletePermission', 'plural', 'single', 'columns', 'displayKey', 'defaultSort', 'viewUrl', 'viewPermission'],
		data() {
			return {
				filters: {
					page: 1,
					dir: 'asc',
					sort: (this.defaultSort)?this.defaultSort:'name',
					search: '',
					filters: {}
				},
				filterData: {},
				total: 1,
				filtering: false,
				loading: false,
				deleting: null,
				deleteLoading: false,
				items: [],
				visible: [],
				hidden: []
			};
		},
		computed: {
			user() {
				return this.$store.state.user;
			},
			width() {
				return this.$store.state.screenWidth;
			}
		},
		watch: {
			'filters.page': function() {
				this.load();
			},
			'filters.sort': function() {
				this.load();
			},
			'filters.dir': function() {
				this.load();
			},
			width() {
				this.setColumns();
			},
			columns: {
				handler() {
					this.setColumns();
					
				},
				immediate: true
			}
		},
		methods: {
			async navigate(item) {
				if(this.viewUrl && (!this.viewPermission || this.user.can(this.viewPermission))){
					await this.$navigate(this.viewUrl + '/' + item.id);
					return;
				}
				if(this.editUrl && (!this.editPermission || this.user.can(this.editPermission))){
					await this.$navigate(this.editUrl + '/' + item.id);
					return;
				}
				
			},
			setSort(index) {
				if(this.filters.sort !== index) {
					this.filters.dir = 'asc';
					this.filters.sort = index;
					return;
				}
				this.filters.dir = (this.filters.dir === 'asc')?'desc':'asc';
			},
			setColumns() {
				let self = this;
				this.visible = {};
				this.hidden = {};
				Object.keys(this.columns).forEach((column) => {
					if(!self.columns[column].hide || self.columns[column].hide <= self.width) {
						self.visible[column] = self.columns[column];
						return;
					}
					self.hidden[column] = self.columns[column];
				});
			},
			getValue(index, item) {
				let start = item;
				index.split(/\./gi).forEach((key) => {
					if(!start) {
						return;
					}
					start = start[key];
				});
				if(this.columns[index].formatter) {
					return this.columns[index].formatter(start);
				}
				return start;
			},
			async deleteItem() {
				if(this.deleteLoading) {
					return;
				}
				this.deleteLoading = true;
				try {
					const data = await this.$postDelete(this.deleteUrl + '/' + this.deleting.id);
					this.deleting = null;
					this.load();
				} catch(e) {
					if(e.message) {
						this.$setErrors([e.message]);
					}
				}
				this.deleteLoading = false;
			},
			async load(init) {
				if(this.loading) {
					return;
				}
				this.loading = true;
				try {
					if(init === true && this.initUrl) {
						let initData = await this.$get(this.initUrl);
						if(initData.init) {
							this.filters = initData.init;
						}
						delete initData.init;
						this.filterData = initData;
					}
					if(init === true && this.initUrl) {
						this.filters.init = true;
					}
					let data = await this.$post(this.dataUrl, this.filters);
					if(init === true && this.initUrl) {
						delete this.filters.init;
					}
					for(let i = 0; i < data.items.length; i++) {
						data.items[i].open = false;
					}
					this.items = data.items;
					this.total = data.total;
					this.$store.state.mainContent.scrollTop = 0;
				} catch(error) {}
				this.loading = false;
			}
		},
		mounted() {
			this.load(true);
		}
	}
</script>